import {
    USER_LOGOUT,
    TOGGLE_SIDE_BAR,
    REMOVE_SELECTED_BOT,
    UPDATE_SELECTED_BOT,
    UPDATE_SELECTED_BOT_ID,
    TOGGLE_BOT_CUSTOM_STATE,
    CURRENT_TAB_STATUS,
    UPDATE_BOT_DATA,
    UPDATE_BLOCKED_UI_STATE,
    UPDATE_USER_DETAILS,
    UPDATE_BOT_LIST,
    UPDATE_SELECTED_BOT_CONFIG,
    GET_SELECTED_BOT_DATA,
    GET_LOGS_ERROR,
    GET_LOGS,
    GET_LOGS_SUCCESS,
    LOAD_CONFIG_SUCCESS,
    LOAD_CONFIG,
    LOAD_CONFIG_ERROR,
    HIGHLIGHT_SEARCHED_RESULT,
    UPDATE_GENERIC_TAB_STATUS,
    SUCCESS_GENERIC_DATA,
    RELOGIN_USER,
    UPSERT_BOT_DATA,
    RESET_VERSION,
    UPDATE_CURRENT_FIRSTPARAM,
    UPDATE_GENERIC_LANG,
    UPDATE_CREATE_MENU_VISIBILITY,
    UPDATE_CREATE_MENU_DATA,
    UPDATE_CREATE_MENU_TYPE,
    GET_BOT_INFO,
    GET_BOT_INFO_SUCCESS,
    GET_BOT_INFO_ERROR,
    UPDATE_SELECTED_SOURCE,
    GET_SOURCE_LIST_SUCCESS,
    GET_SOURCE_LIST_ERROR
} from '../Actions/actions';

import defaultConfig from '../../../assets/BotForge_Config7.json';
let baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'http://127.0.0.1:5001';

const initialState = {
    SIDE_MENU: false,
    user: {},
    availableBotList: [],
    selectedBot: 'Select Bot',
    selectedBotID: '',
    isCustomBot: false,
    tabListArray: [
        'Chatbot',
        'Testing Page Settings',
        'UI settings',
        'Message settings',
        'Cards',
        'Images',
        'Framework',
        'Custom JS',
        'Custom CSS'
    ],
    editableBotData: {},
    selectedBotData: {},
    currentActiveTab: 'chatbot',
    blockedUi: false,
    isLoggedIn: false,
    selsctedBotdata: {},
    highlightSearchedData: {},
    clearKey: 'clearKey',
    currentLanguage: 'en',
    currentGenericLang: 'en',
    genericBotData: {},
    reloginUser: false,
    version: '',
    kbId: undefined,
    currentFirstParam: undefined,
    selectedSource: undefined,
    sourceList: [],
}

const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGOUT:
            return {
                ...state,
                isLoggedIn: false
            }

        case UPDATE_USER_DETAILS:
            return {
                ...state,
                user: {
                    userName: action.value.firstName + ' ' + action.value.lastName
                },
                isLoggedIn: true,
                blockedUi: true,
                reloginUser: false
            }

        case UPDATE_BOT_LIST:
            if(state.reloginUser) {
                return {
                    ...state,
                    availableBotList: action.value,
                    isLoggedIn: false,
                    blockedUi: false
                }
            } else {
                return {
                    ...state,
                    availableBotList: action.value,
                    isLoggedIn: true,
                    blockedUi: false
                }
            }

        case TOGGLE_SIDE_BAR:
            return {
                ...state,
                SIDE_MENU: action.value
            };

        case GET_SELECTED_BOT_DATA:
            return {
                ...state,
                blockedUi: true
            }

        case UPDATE_SELECTED_BOT_CONFIG:
            let ts = new Date().getTime();
            let currentBotData = JSON.parse(JSON.stringify(action.value));
            let botDetails;
            state.kbId = action.kbId;
            state.availableBotList.forEach(elem => {
                if (action.botId === elem.id) {
                    botDetails = elem;
                    return
                }
            });
            let genericConfig = defaultConfig;
            if(Object.keys(state.genericBotData).length) {
                genericConfig = JSON.parse(JSON.stringify(state.genericBotData));
                delete genericConfig.endpoint;
                delete genericConfig.langISO;
                delete genericConfig._id;
            }
            if((typeof(currentBotData.customBotUI) === 'boolean' || typeof(currentBotData.CUSTOM_BOT_UI) === 'boolean') && !currentBotData.CUSTOM_BOT_UI) {
                genericConfig.botId = action.botId;
                genericConfig.SETTINGS.BOTID = action.botId;
                return {
                    ...state,
                    selectedBot: botDetails.displayName,
                    selectedBotID: botDetails.id,
                    selsctedBotdata: botDetails,
                    isCustomBot: false,
                    editableBotData: genericConfig,
                    selectedBotData: genericConfig,
                    currentLanguage: botDetails.langISO,
                    currentGenericLang: botDetails.langISO,
                    currentFirstParam: botDetails.id,
                    clearKey: ts,
                    version: ''
                }
            } else if (currentBotData.CUSTOM_BOT_UI && !currentBotData.CUSTOM_BOT_UI.VALUE) {
                genericConfig.botId = action.botId;
                genericConfig.SETTINGS.BOTID = action.botId;
                return {
                    ...state,
                    selectedBot: botDetails.displayName,
                    selectedBotID: botDetails.id,
                    selsctedBotdata: botDetails,
                    isCustomBot: false,
                    editableBotData: genericConfig,
                    selectedBotData: genericConfig,
                    currentLanguage: botDetails.langISO,
                    currentGenericLang: botDetails.langISO,
                    currentFirstParam: botDetails.id,
                    clearKey: ts,
                    version: ''
                }
            } else {
                return {
                    ...state,
                    selectedBot: botDetails.displayName,
                    selectedBotID: botDetails.id,
                    selsctedBotdata: botDetails,
                    isCustomBot: true,
                    editableBotData: currentBotData,
                    selectedBotData: currentBotData,
                    currentLanguage: botDetails.langISO,
                    currentGenericLang: botDetails.langISO,
                    currentFirstParam: botDetails.id,
                    clearKey: ts,
                    version: ''
                }
            }
        case REMOVE_SELECTED_BOT:
            return {
                ...state,
                selectedBot: 'Select Bot',
                selectedBotID: ''
            }

        case UPDATE_SELECTED_BOT:
            return {
                ...state,
                isCustomBot: action.value,
                version: ''
            }

        case UPDATE_SELECTED_BOT_ID:
            return {
                ...state,
                selectedBotID: action.value.id,
                selectedBot: action.value.name
            }

        case TOGGLE_BOT_CUSTOM_STATE:
            return {
                ...state,
                isCustomBot: action.value
            }

        case CURRENT_TAB_STATUS:
            return {
                ...state,
                currentActiveTab: action.value
            }

        case UPDATE_BOT_DATA:
            const actionValue = JSON.parse(JSON.stringify(action.value));
            if(action.times) {
                return {
                    ...state,
                    editableBotData: actionValue,
                    currentLanguage: actionValue.langISO,
                    currentGenericLang: actionValue.langISO,
                    clearKey: action.times,
                    version: ''
                }
            } else if(action.version) {
                return {
                    ...state,
                    editableBotData: actionValue,
                    currentLanguage: actionValue.langISO,
                    currentGenericLang: actionValue.langISO,
                    clearKey: action.times,
                    version: action.version
                }
            } else {
                return {
                    ...state,
                    editableBotData: actionValue,
                    currentLanguage: actionValue.langISO,
                    currentGenericLang: actionValue.langISO,
                    version: ''
                }
            }
        case UPDATE_BLOCKED_UI_STATE:
            let tsn = new Date().getTime();
            return {
                ...state,
                blockedUi: action.value,
                clearKey: tsn
            }
        case GET_LOGS:
            return {
                ...state,
                botLogs: null
            }
        case GET_LOGS_SUCCESS:
            return {
                ...state,
                botLogs: action.response.data.rows,
                logsCount: action.response.data.count
            }
        case GET_LOGS_ERROR:
            return {
                ...state,
                botLogs: null
            }
        case LOAD_CONFIG:
            return {
                ...state
            }
        case LOAD_CONFIG_SUCCESS:
            return {
                ...state
            }
        case LOAD_CONFIG_ERROR:
            return {
                ...state
            }
        case HIGHLIGHT_SEARCHED_RESULT:
            return {
                ...state,
                highlightSearchedData: action.data
            }

        case UPDATE_GENERIC_TAB_STATUS:
            return {
                ...state,
                currentGenericActiveTab: action.currentTab
            }
        case SUCCESS_GENERIC_DATA:
            return {
                ...state,
                genericBotData: JSON.parse(JSON.stringify(action.data)),
                clearKey: new Date().getTime()
            }
        case RELOGIN_USER:
            return {
                ...state,
                isLoggedIn: false,
                reloginUser: true
            }
        case UPSERT_BOT_DATA:
            return {
                ...state,
                version: ''
            }
        case RESET_VERSION:
            return {
                ...state,
                version: ''
            }
        case UPDATE_CURRENT_FIRSTPARAM:
            return {
                ...state,
                currentFirstParam: action.value
            }
        case UPDATE_GENERIC_LANG:
            return {
                ...state,
                currentGenericLang: action.value
            }
        
        case UPDATE_CREATE_MENU_VISIBILITY:
            return {
                ...state,
                showCreateMenu: action.value
            }
        
        case UPDATE_CREATE_MENU_DATA:
            return {
                ...state,
                createMenuData: action.value
            }
        
        case UPDATE_CREATE_MENU_TYPE:
            return {
                ...state,
                createMenuType: action.value
            }
        case GET_BOT_INFO:
            return {
                ...state,
            }
        case GET_BOT_INFO_SUCCESS: 
            const botData = action?.value;
            if(!botData || !botData?.id) {
                return {
                    ...state,
                }
            }
            localStorage.setItem('bot_id', botData?.id);
            localStorage.setItem('bot_name', botData?.displayName || botData?.name || botData?.id);
            
            return {
                ...state,
                botInfo: {
                    id: botData?.id,
                    name: botData?.displayName || botData?.name || botData?.id || ''
                }
            }
        case GET_BOT_INFO_ERROR: 
            return {
                ...state,
            }
        case UPDATE_SELECTED_SOURCE: 
            return {
                ...state,
                selectedSource: action.data
            }
        case GET_SOURCE_LIST_SUCCESS: 
            return {
                ...state,
                sourceList: action.value
            }
        case GET_SOURCE_LIST_ERROR: 
            return {
                ...state,
                sourceList: []
            }
        default:
            return state;
    }
}

export default uiReducer;